import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    
    // Clone the template content
    const content = this.templateTarget.content.cloneNode(true)
    
    // Append it to the container
    this.containerTarget.appendChild(content)
  }

  remove(event) {
    event.preventDefault()
    
    const wrapper = event.target.closest(".dynamic-input-wrapper")
    if (wrapper) {
      wrapper.remove()
    }
  }
}
